import { render, staticRenderFns } from "./StartupEditTeam.vue?vue&type=template&id=69674e28&scoped=true"
import script from "./StartupEditTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./StartupEditTeam.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69674e28",
  null
  
)

export default component.exports